import React from 'react';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons/faClipboardCheck';

import Authenticated from 'Components/Layouts/Authenticated';
import { PrimaryButton } from 'Components/Button';
import { ModalTrigger } from 'Components/Modal';
import CreateCmsElementRecordModal from 'Components/Partials/Modals/CreateCmsElementRecordModal';
import ViewCmsElementRecords from 'Components/Utilities/ViewCmsElementRecords';
import User from 'Services/User';

import { translation } from 'Services/TranslationHelpers';

export default class QualityAssurance extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        const isViewable = User.isAdmin
            ? true
            : !User.belongsToGroup('Staff');

        return (
            <Authenticated title="Quality Assurance" titleIcon={faClipboardCheck}>
                <div className="mb-6">
                    <ModalTrigger
                        component={CreateCmsElementRecordModal}
                        props={{
                            showElementsDropdown: true,
                            element_id: null,
                            element_record_id: null,
                            service_user_id: null,
                            quality_assurance: true
                        }}
                    >
                        <PrimaryButton
                            className="font-league-spartan font-bold text-xl"
                            text={translation('cms', 'quality_assurance_submit')}
                        />
                    </ModalTrigger>
                </div>

                <ViewCmsElementRecords
                    quality_assurance={true}
                    isViewable={isViewable}
                />
            </Authenticated>
        );
    }
}
